export default __webpack_public_path__ + "static/media/triangle.e705f6c2.svg";